import React, { useState } from 'react';
import ConfirmDialog from 'components/ConfirmDialog';
import { formatDateTime } from 'utils/datetime';

/**
 * Channel details floating window (modal).
 * Shows channel metadata and lets the user delete the channel.
 */
const ChannelDetailsModal = ({ channel, memberCount, onClose, onDelete }) => {
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [error, setError] = useState(null);

  const handleDelete = async () => {
    setError(null);
    try {
      await onDelete(channel.id);
      setShowConfirmDelete(false);
      onClose();
    } catch (err) {
      setShowConfirmDelete(false);
      setError(err.message);
    }
  };

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog" onMouseDown={onClose}>
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          onMouseDown={(e) => e.stopPropagation()}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <i className="bi bi-info-circle me-2" aria-hidden="true"></i>
                Channel details
              </h5>
              <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              {error && (
                <div className="alert alert-danger d-flex align-items-center gap-2" role="alert">
                  <i className="bi bi-exclamation-octagon-fill" aria-hidden="true"></i>
                  {error}
                </div>
              )}
              <dl className="gh-channel-details">
                <dt className="text-muted-gh small">Channel name</dt>
                <dd># {channel.name}</dd>
                <dt className="text-muted-gh small">Created</dt>
                <dd>{formatDateTime(channel.createdAt)}</dd>
                <dt className="text-muted-gh small">Members online</dt>
                <dd>{memberCount}</dd>
              </dl>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-gh-danger"
                onClick={() => setShowConfirmDelete(true)}
              >
                <i className="bi bi-trash3 me-2" aria-hidden="true"></i>
                Delete channel
              </button>
            </div>
          </div>
        </div>
      </div>

      {showConfirmDelete && (
        <ConfirmDialog
          title="Delete channel"
          message={<>Delete channel <strong># {channel.name}</strong>? This action cannot be undone.</>}
          confirmLabel="Delete"
          danger
          onConfirm={handleDelete}
          onCancel={() => setShowConfirmDelete(false)}
        />
      )}
    </>
  );
};

export default ChannelDetailsModal;
